import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllListings,
  addListing,
  removeListing,
  updateListing,
} from '../actions/listing.action'
import { Listing, UpdateListingThunkParams } from '@dataTypes/index'

type ListingState = {
  data: Listing[] | null
  loading: boolean
  error: null
}

const initialState: ListingState = {
  data: null,
  loading: false,
  error: null,
}

const listingsSlice = createSlice({
  name: 'listings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllListings.fulfilled,
      (state, action: PayloadAction<Listing[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllListings.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllListings.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addListing.fulfilled,
      (state, action: PayloadAction<Listing>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addListing.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addListing.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateListing.fulfilled,
      (state, action: PayloadAction<UpdateListingThunkParams>) => {
        const { id, body: updatedListing } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedListing }
        }
        state.loading = false
      },
    )
    builder.addCase(updateListing.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateListing.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeListing.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeListing.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeListing.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default listingsSlice.reducer
